
import { getServiceUrlSync, isProxyEnabledSync } from '@/config/proxy';

/**
 * Конфигурация для Google Maps API с поддержкой проксирования
 */

// API ключ для Google Maps
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCoCNFQhyg8mpTmesOi_8ue_SxwliHoRFY';

// Получаем базовый URL для Google Maps API с учетом проксирования
const getGoogleMapsApiUrl = (): string => {
  if (isProxyEnabledSync('googleMaps')) {
    return getServiceUrlSync('googleMaps');
  }
  return 'https://maps.googleapis.com';
};

export const GOOGLE_MAPS_API_URL = getGoogleMapsApiUrl();

// Настройки карты по умолчанию как обычный объект
// Используем обычный тип Record вместо google.maps.MapOptions
export const MAP_DEFAULT_OPTIONS = {
  mapTypeControl: true,
  streetViewControl: false,
  fullscreenControl: true,
  zoomControl: true,
  mapTypeId: "roadmap", // Вместо google.maps.MapTypeId.ROADMAP используем строковый литерал
  disableDefaultUI: false,
  clickableIcons: true,
};

// Функция для получения полного URL к Google Maps API
export const getGoogleMapsScriptUrl = (): string => {
  const baseUrl = GOOGLE_MAPS_API_URL;
  return `${baseUrl}/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
};

// Функция для получения URL к Geocoding API
export const getGeocodingApiUrl = (latitude: number, longitude: number): string => {
  const baseUrl = GOOGLE_MAPS_API_URL;
  return `${baseUrl}/maps/api/geocode/json?latlng=${latitude},${longitude}&language=ru&key=${GOOGLE_MAPS_API_KEY}`;
};

// Логирование конфигурации Google Maps
console.log('🗺️ Конфигурация Google Maps:', {
  apiUrl: GOOGLE_MAPS_API_URL,
  proxyEnabled: isProxyEnabledSync('googleMaps')
});
